import React from 'react'
import { dayjsFormat } from '../../shared/utilities/util'
import { useGetCompanyInvoicesQuery } from '../../store/api/adminApi'
import SharedTable from '../../shared/components/Table'
import { IconButton } from '@mui/material'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import { useTablePagination } from '../../shared/hooks'

const columns = [
  { id: 'planName', label: 'Plan Name', minWidth: 'auto' },
  { id: 'amountPaid', label: 'Amount Paid', minWidth: 'auto' },
  { id: 'dateOfSubscription', label: 'Date Of Subscription', type: 'date', minWidth: 'auto' },
  { id: 'invoicePdf', label: 'Invoice PDF', minWidth: 'auto' },
]

const Invoice = ({ id }) => {
  const { data: invoiceRaw, isLoading: userLoader } = useGetCompanyInvoicesQuery(id, { skip: !id })
  const invoiceData = invoiceRaw?.userInvoiceData ?? []
  const { page, rowsPerPage, handlePageChange, handleRowsPerPageChange } = useTablePagination({ key: 'invoices' })

  const formattedData = invoiceData?.map((data) => ({
    planName: data?.planName,
    amountPaid: data?.amountPaid ? data?.amountPaid : 'N/A',
    dateOfSubscription: dayjsFormat(data?.dateOfSubscription, 'MM/DD/YYYY hh:mm A'),
    invoicePdf: (
      <IconButton
        onClick={() => window.open(data?.invoicePdf)}
        aria-label="Download invoice PDF"
        sx={{ color: 'error.main' }}
        size="small"
      >
        <PictureAsPdfOutlinedIcon fontSize="small" />
      </IconButton>
    ),
  }))

  return (
    <SharedTable
      columns={columns}
      data={formattedData}
      page={page}
      tableBodyLoader={userLoader}
      rowsPerPage={rowsPerPage}
      totalRows={formattedData?.length || 0}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      searchFilter={undefined}
      onSearch={() => {}}
      searchFilterVisible={false}
      selectableRows={false}
      onRowClick={() => {}}
      getRowHref={undefined}
      showDeletedToggle={false}
      switchProps={undefined}
    />
  )
}

export default Invoice
